import * as Sentry from '@sentry/react';

export const sentryCaptureRenderError = (data: { error: unknown; source: string }) => {
  const { error, source } = data;
  const errorObject = error instanceof Error ? error : new Error(String(error));

  Sentry.captureException(errorObject, {
    fingerprint: ['render_error', source, errorObject.message],
    tags: { type: 'render_error', source },
    extra: {
      href: typeof window === 'undefined' ? undefined : window.location.href,
      original_stack: errorObject.stack,
    },
  });
};
